import type { SxProps, Theme } from '@mui/material/styles'

import {
  CAMPAIGN_WIZARD_HORIZONTAL_OUTSIDE_GAP_PX,
  CAMPAIGN_WIZARD_VERTICAL_GUTTER_PX,
} from '@/features/campaigns/lib/campaignWizardLayout'
import { APP_SHELL_PAGE_PADDING_PX } from '@/shared/layout/appShellPageLayout'

export function appShellMainPaddingSx(
  usesInstrumentPageGutter: boolean,
  isCampaignWizard: boolean,
  instrumentPageGutterPx: number,
): SxProps<Theme> {
  if (!usesInstrumentPageGutter) {
    return { p: `${APP_SHELL_PAGE_PADDING_PX}px` }
  }
  if (isCampaignWizard) {
    return {
      pt: `${CAMPAIGN_WIZARD_VERTICAL_GUTTER_PX}px`,
      pr: `${CAMPAIGN_WIZARD_HORIZONTAL_OUTSIDE_GAP_PX}px`,
      pb: `${CAMPAIGN_WIZARD_VERTICAL_GUTTER_PX}px`,
      pl: `${CAMPAIGN_WIZARD_HORIZONTAL_OUTSIDE_GAP_PX}px`,
    }
  }
  return {
    pt: `${instrumentPageGutterPx}px`,
    pr: `${instrumentPageGutterPx}px`,
    pb: `${instrumentPageGutterPx}px`,
    pl: `${instrumentPageGutterPx}px`,
  }
}
